import {
  Component,
  Input,
  AfterViewInit,
  ElementRef,
  OnInit,
  ViewChild,
  ViewContainerRef,
  EventEmitter,
  Output,
} from '@angular/core';
import { LMFormPanelBase } from './lm-form-panel-base';
import { LMFormContentTemplateComponent } from './lm-form-content-template.component';
import { LMModel } from './model';
import { Observer, Observable } from 'rxjs';
import { LMUrlInfoBuilderService } from '@services/lm-url-info-builder.service';
import { LMRefreshRequest } from '@app/components';

@Component({
  selector:    'lm-form-panel-template',
  templateUrl: 'lm-form-panel-template.component.html',
  styleUrls:   [ 'lm-form-panel-template.component.scss' ]
})

export class LMFormPanelTemplateComponent implements LMFormPanelBase, AfterViewInit, OnInit {

  @ViewChild('LMFormTemplateComponent') templateFormComponent: LMFormContentTemplateComponent;

  @Input() formSpec: LMFormSpec = null;
  @Input() model: LMModel;
  @Input() placeHolder: ViewContainerRef;
  @Input() sourceDataView: LMDataView;
  @Input() formOptions: LMFormOptions;
  @Input() specFields: LMSpecFields;
  @Input() layout: LMFormLayout;
  @Input() needsReload: boolean;
  @Input() panelDataState: LMPanelDataState;
  @Input() panelId: string;
  @Input() busFormPanel: LMCompositePanelSpec;
  @Input() displayWhenIndex: number;
  @Input() hideLayout = false;

  @Input() set activated(activated: boolean) {
    this._activated = activated;
  }

  @Input() set fromDataView(fromDataView: LMDataView) {
    this._fromDataView = fromDataView;
  }

  get fromDataView(): LMDataView {
    if (this.needsReload || (this.panelDataState === 'stale_needsReload')) {

      // -------------------------------------------------------------
      // return null fromDataView so tabs non activated tabs will
      // not load their data data.
      // -------------------------------------------------------------
      return null;
    }

    return this._fromDataView;
  }

  @Output() contentModified = new EventEmitter<any>();
  @Output() formPanelContentLoading = new EventEmitter<any>();
  @Output() formPanelContentLoaded = new EventEmitter<any>();
  @Output() fieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();

  private _activated = false;
  private _fromDataView: LMDataView;

  public displayPanelId: string;
  public formUrlInfo: LMFormUrlInfo;

  get activated() {
    return this._activated;
  }
  constructor(
    public lmUrlInfoBuilderService: LMUrlInfoBuilderService,
    private elementRef: ElementRef
  ) {}

  ngOnInit() {
    this.displayPanelId = this.panelId;
    this.formUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(this.formSpec);
  }

  ngAfterViewInit() {
  }

  public getPanelHeight(): number {
    if (this.elementRef) {
      return this.elementRef.nativeElement.offsetHeight;
    }
    return 0;
  }

  onContentModified(event: any) {
    this.contentModified.emit(event);
  }

  onFieldEvent(event: any) {
    this.fieldEvent.emit(event);
  }

  onFormTemplateLoading(event: any) {
    this.formPanelContentLoading.emit(event);
  }

  onFormTemplateLoaded(event: any) {
    this.formPanelContentLoaded.emit(event);
  }

  public dynamicChildVisibility(): LMDynamicChildVisibility {
    return this.busFormPanel ? this.busFormPanel.dynamicChildVisibility : null;
  }

  public refresh(request?: LMRefreshRequest): Observable<boolean> {
    return this.templateFormComponent.refresh();
  }

  public save(callBack: Observer<boolean>, skipToast?: boolean) {
    if (this.templateFormComponent) {
      this.templateFormComponent.save(callBack, skipToast);
    } else {
      // NOTHING TO SAVE
      callBack.next(true);
      callBack.complete();
    }
  }

  public isDirty(): boolean {
    if (this.templateFormComponent) {
      return this.templateFormComponent.isDirty();
    } else {
      return false;
    }
  }

  saveCompositeComponentState(): void {
    // noop
  }

  clearCompositeComponentState(): void {
    // noop
  }
}
